import { Component, OnInit, ElementRef } from '@angular/core';
import { Meta } from '@angular/platform-browser';

import { TitleService } from 'src/app/shared/services/title.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private titleService: TitleService,
    private _elementRef: ElementRef,
    private meta: Meta) { }

  ngOnInit(): void {
    this.meta.addTags([
      { name: 'description', content: 'RanSEPs provides a framework for bacterial genome re-annotation and novel small proteins (SEPs) detection adjusting the search to different genomic features that govern protein-coding capabilities.' },
      { name: 'author', content: 'anas.gharrab@gmail.com' },
      { name: 'keywords', content: 'RanSEPs, Framework, Genome, small proteins, SEPs, protein-coding' }
    ]);
    this.titleService.init();
    this._elementRef.nativeElement.removeAttribute("ng-version");
  }
}
